<template>
  <div>
    <navbar/>
    <container/>
  </div>
</template>

<script>
import Nav from "../../Nav";
import Container from "./LicencaPrevidenciariaContainerLista"
export default {
  name: "LicencaPrevidenciariaLista",
  components: {
    "navbar": Nav,
    "container": Container
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/licencaPrevidenciaria/LicencaPrevidenciariaLista.vue